import { useQuery } from '@tanstack/react-query';

import { chamarApi } from '../api/cliente.ts';

export type OperadoraCadastrada = { id: string; nome: string; ativa: boolean; usos: number };

/**
 * As operadoras do cadastro (NEX-228), para toda tela que escolhe uma.
 *
 * `nomes` traz só as ativas: é o que se oferece em registro novo. Quem edita um
 * registro antigo junta o valor gravado com `comValorAtual`, para uma operadora
 * desativada não sumir da ficha que já a usava.
 *
 * `pronta` existe por causa do `<select>` não controlado: o `defaultValue` só
 * vale na primeira pintura, e as opções chegam depois. Quem usa passa `pronta`
 * na `key` do campo, e ele nasce de novo quando a lista chega.
 */
export function useOperadoras(): { nomes: string[]; todas: OperadoraCadastrada[]; pronta: boolean } {
  const consulta = useQuery({
    queryKey: ['operadoras'],
    queryFn: () => chamarApi<OperadoraCadastrada[]>('/operadoras'),
    staleTime: 60_000,
  });

  const todas = consulta.data ?? [];
  return {
    nomes: todas.filter((operadora) => operadora.ativa).map((operadora) => operadora.nome),
    todas,
    pronta: consulta.isSuccess,
  };
}
